/////////////////////////////////////////////////////////
// ウリドキプラスから移植したPIXフォーム
/////////////////////////////////////////////////////////

const pixCategories = [
  {
      name: 'スマホ・カメラ・家電・オーディオ',
      id: "8352e9e9-2adc-4c93-b450-c1b8ba6c7e27",
      short_name: 'electric_devices',
      childCategories: [
          {id: "1da67a8f-5279-401f-9ddf-cde1c756a94d", name: "スマホ", short_name: 'phone'},
          {id: "7a737d27-08c3-4a38-9533-ac3b7a18462d", name: "カメラ", short_name: 'camera'},
          {id: "c3917090-1de0-4f76-9061-f90fa6a54ec8", name: "PC・タブレット", short_name: 'pc_tablet'},
          {id: "6c2aad38-43f1-47a1-9cfa-ba915162f579", name: "オーディオ・スピーカー", short_name: 'audio'},
          {id: "09384233-4b18-48c9-bc17-2201c0c7c6f9", name: "家電", short_name: 'kaden'}
      ]
  },
  {
      name: 'ゲーム・古本・CD・DVD',
      id: "9d209246-b5c5-44a2-8ea5-08c8ed736610",
      short_name: 'media',
      childCategories: [
          {id: "909e72b0-5503-444e-a9b3-dcde293cc76b", name: "ゲーム機本体・ゲームソフト", short_name: 'game'},
          {id: "d61e7d4a-c13a-4a22-b1d6-42f857f4a895", name: "古本", short_name: 'book'},
          {id: "142d9228-2911-4246-91d3-acccb69b645d", name: "CD・DVD", short_name: 'cd_dvd'},
          {id: "cccce963-67c0-4262-ab17-ba045aa6d3a5", name: "レコード", short_name: 'record' }
      ]
  },
  {
      name: 'トレカ・フィギュア・ホビー',
      id: "292cd196-f793-4c36-b483-480fd05638f1",
      short_name: 'hobby',
      childCategories: [
          {id: "3d560a03-d8f9-4e8b-acc7-3b3fe8842f1e", name: "トレカ", short_name: 'tradingcard'},
          {id: "e983e6ae-7571-4ae7-8749-6b6381e788fe", name: "フィギュア・プラモデル", short_name: 'figure'},
          {id: "ccf58920-cb7c-4585-a889-932221c04330", name: "エアガン・ミリタリー用品", short_name: 'airgun'},
          {id: "7bd46195-5ccb-4b81-8c07-0d38e8e0479a", name: "ミニカー・ラジコン", short_name: 'minicar'},
          {id: "199f7b00-e72c-4adc-93cb-69b569f214f0", name: "鉄道模型・プラレール", short_name: 'train_model'},
          {id: "34cbbc18-5c99-4163-8b9e-900c7a4d166a", name: "その他のおもちゃ", short_name: 'other_toy'}
      ]
  },
  {
      name: 'ブランドバッグ・高級時計',
      id: "cc6c688a-bb52-4089-825b-08392f3d9513",
      short_name: 'brand_watch',
      childCategories: [
          {id: "f52ea681-6346-40bc-8fdd-b11108fbae78", name: "ブランドバッグ", short_name: 'brand_bag'},
          {id: "4e24eb12-fd47-40d6-8736-7b645ab26531", name: "高級時計", short_name: 'watch'},
          {id: "7be2cb94-b857-4b3c-81f0-312f9e27f8b4", name: "ブランド財布・小物", short_name: 'wallet_accessories'}
      ]
  },
  {
      name: '着物・美術品・骨董品',
      id: "f45504c2-73e0-45a7-9bb0-7bc99fefe64b",
      short_name: 'kimono_art',
      childCategories: [
          {id: "61f0777e-49a1-439a-925f-ac2039fbb109", name: "着物", short_name: 'kimono'},
          {id: "16f7654d-b4f3-4816-a053-3edcb0d270ef", name: "美術品・骨董品", short_name: 'art'}
      ]
  },
  {
      name: 'お酒・喫煙具',
      id: "d6d8fba5-1882-4a82-89bb-c5a139bfd40b",
      short_name: 'sake_cigarette',
      childCategories: [
          {id: "a7fa1021-b84c-41cc-9c19-04a0c5a134f8", name: "お酒", short_name: 'sake'},
          {id: "d447752a-5ded-4631-a73f-fe01ccb501f5", name: "喫煙具", short_name: 'cigarette'}
      ]
  },
  {
      name: 'ピアノ・楽器・PA機材',
      id: "1571a5f0-58dd-4ec0-96e8-9a2c2b4b4873",
      short_name: 'gakki',
      childCategories: []
  },
  {
      name: 'カー用品・バイク用品・自転車',
      id: "45cd3a50-3876-43e7-836e-939a3cafe3df",
      short_name: 'car_bike',
      childCategories: [
          {id: "75900318-cee6-4abd-be43-cb3a383ed1a9", name: "カー用品", short_name: 'kuruma'},
          {id: "9358cac5-638f-4c7b-ac10-09ac51c49c3e", name: "バイク用品", short_name: 'bike'},
          {id: "777d42ed-76a4-4fb2-ae69-af3dfa4fa80f2", name: "自転車", short_name: 'bicycle'}
      ]
  },
  {
      name: 'スポーツ・アウトドア',
      id: "5a7232e0-0941-4cc1-88ad-b01696044e5a",
      short_name: 'sport_outdoor',
      childCategories: [
          {id: "d3333c3c-2be1-47fa-a68c-6e3d9d0917ab", name: "ゴルフ用品", short_name: 'golf'},
          {id: "d21c7956-4bc5-4131-bff7-2ad3ee7772e0", name: "釣具", short_name: 'fishing'},
          {id: "81bb250a-2594-41f8-944c-a2a708a5ea64", name: "アウトドア用品", short_name: 'outdoor'},
          {id: "10b784b6-2c73-4ad9-b74b-469b7b2b507c", name: "その他のスポーツ用品", short_name: 'other_sport'}
      ]
  },
  {
      name: 'ベビー・医療・介護',
      id: "9373ddd6-a2d7-43ce-a4ac-10365ae4c25d",
      short_name: 'baby_medical_kaigo',
      childCategories: [
          {id: "690f4c05-30e0-41ad-bbc7-65b6d046d829", name: "ベビー用品", short_name: 'baby_item'},
          {id: "517bc6cc-f293-449a-aec7-be8182e992e3", name: "医療機器", short_name: 'medical_device'},
          {id: "6e2a09a5-9cbb-4b8d-a4bf-0940a0589b07", name: "介護用品", short_name: 'kaigo'}
      ]
  },
  {
      name: '古着・ファッション',
      id: "3741094c-6f74-41ee-974a-ec2296d08d20",
      short_name: 'furugi',
      childCategories: []
  },
  {
      name: '金・ジュエリー',
      id: "123164c1-f50b-4833-b223-d0912ee97819",
      short_name: 'metal_jewelry',
      childCategories: [
          {id: "b7e99fb0-0bc4-41e6-d858-14bd1de0c224", name: "金・貴金属", short_name: 'gold'},
          {id: "eb08e685-5269-4b7c-04e4-c807d254243c", name: "宝石", short_name: 'metal_gems'}
      ]
  },
  {
      name: '家具・寝具・食器',
      id: "92399300-05fa-45f0-b98f-8c3c41badb54",
      short_name: 'kagu',
      childCategories: []
  },
  {
      name: 'コスメ・美容・健康器具',
      id: "5e091879-19c9-4a13-88ec-af65ab1d1c05",
      short_name: 'cosmetic_biyoukiki',
      childCategories: []
  },
  {
      name: 'チケット・切手・金券',
      id: "3b3c7500-f744-4548-9e76-8a5ddbfe6991",
      short_name: 'ticket_and_stamp',
      childCategories: []
  },
  {
      name: '電動工具・農機具・業務用機械',
      id: "4b4113e6-8d6b-439e-a8b0-b0f0cd60156a",
      short_name: 'electric-tools',
      childCategories: []
  }
];

function append_pix_categories(childCategoryHash, htmlId, position) {
  if (childCategoryHash.length == 0) {
    $(`#child_category_${position}`).hide();
    $(`#form-link-image_${position}`).addClass('field_hint');
  } else {
    generate_pix_category_selector(childCategoryHash, htmlId);
    $(`#parent_category_${position}`).prop('disabled', false);
    if ($(`#parent_category_${position}`).val() != '') {
      $(`#form-link-image_${position}`).removeClass('field_hint');
      $(`#child_category_${position}`).show();
    }
  }
}

function generate_pix_category_selector(childCategoryHash, htmlId) {
  childCategoryHash.forEach( (childCategory) =>
      $(htmlId).append(`<option name="${childCategory.name}" value="${childCategory.id}">${childCategory.name}</option>`)
  );
}

function generate_pix_child_category(parentCategoryId) {
  return categoryFind(parentCategoryId).childCategories;
}

function categoryFind(id){
  return pixCategories.find((category) => category.id === id);
}

function changeParentCategory(parentCategoryId){
  if(parentCategoryId === ''){
    return;
  }

  const childCategoryHash = generate_pix_child_category(parentCategoryId);
  $('#child_category_kaitori_form option').remove();
  $('#child_category_kaitori_form').append("<option value=''>カテゴリを選択して下さい</option>");
  append_pix_categories(childCategoryHash, '#child_category_kaitori_form', 'kaitori_form');
  $(this).removeClass('field_hint');
  $('#child_category_kaitori_form').addClass('field_hint');
  $('#pix-form-link_kaitori_form').attr('href', generate_pix_form_link(parentCategoryId, ''));
}

function setLoadedCategorySelector(linkElement, parentCategorySelector, childCategorySelector, category, childCategory){
  parentCategorySelector.find(`option[value=${category.id}]`).attr("selected", "selected");
  parentCategorySelector.removeClass('field_hint');
  const $imageElement = $(linkElement).children('img');
  if(childCategory === null || category.childCategories.length === 0) {
      $imageElement.addClass('field_hint');
      return linkElement.attr('href', generate_pix_form_link(category.id, null));
  }
  childCategorySelector.show();
  category.childCategories.forEach( (childCategory) =>
      childCategorySelector.append(`<option name="${childCategory.name}" value="${childCategory.id}">${childCategory.name}</option>`)
  );
  childCategorySelector.find(`option[value=${childCategory.id}]`).attr("selected", "selected");
  $imageElement.addClass('field_hint');
  return linkElement.attr('href', generate_pix_form_link(category.id, childCategory.id));
}

function generate_pix_form_link(parentCategory, childCategory) {
  if(!childCategory){
    return `/pix/items/new?parent_category_id=${parentCategory}`;
  }
  return `/pix/items/new?parent_category_id=${parentCategory}&category_id_from_mall_top=${childCategory}`;
}

export const initForCategoryLandingPage = () => {
  if($('#parent_category_kaitori_form')){
    const parentCategoryId = $('#parent_category_kaitori_form').val();
    const category = categoryFind(parentCategoryId);
    setLoadedCategorySelector($('#pix-form-link_kaitori_form'), $('#parent_category_kaitori_form'), $('#child_category_kaitori_form'), category, null);
  }
  $('#parent_category_kaitori_form').on('change', function(){
    const parentCategoryId = $(this).val();
    changeParentCategory(parentCategoryId);
  });
  $('#child_category_kaitori_form').on('change', function(){
    const parentCategory = $('#parent_category_kaitori_form').val();
    const childCategory = $(this).val();
    $('#pix-form-link_kaitori_form').attr('href', generate_pix_form_link(parentCategory, childCategory));
    $(this).removeClass('field_hint');
    $('#form-link-image_kaitori_form').addClass('field_hint');
  });
};
